//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface NutritionState {
  nutritionData: any[];
  loading: boolean;
  error: string | null;
}

const initialState: NutritionState = {
  nutritionData: [],
  loading: false,
  error: null,
};

interface FetchNutritionPayload {
  sitecode: string;
  issync: boolean;
  
}

// Async Thunk to fetch nutrition data
export const fetchNutrition = createAsyncThunk(
  'nutrition/fetchNutrition',
  async (payload: FetchNutritionPayload) => {
    try {
      const { token, ...requestPayload } = payload;
      const response = await axiosInstance.post(
        `${BASE_URL}/api/v1/Nutrition`,
        requestPayload,
        {
          headers: {
            'Token': "8sr2y800-0db2-4984-a363-9c292205baed",
          },
        }
      );

      const data = response.data;
      if (!data.success) {
        throw new Error(data.errormessage || 'Failed to fetch nutrition data');
      }

      return data.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.errormessage || 'Failed to fetch nutrition data');
    }
  }
);

// Slice
const nutritionSlice = createSlice({
  name: 'nutrition',
  initialState,
  reducers: {
    clearNutritionData: (state) => {
      state.nutritionData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNutrition.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNutrition.fulfilled, (state, action) => {
        state.loading = false;
        state.nutritionData = action.payload;
      })
      .addCase(fetchNutrition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch nutrition data';
      });
  },
});

export const { clearNutritionData } = nutritionSlice.actions;
export default nutritionSlice.reducer;
